import { FETCH_EMPLOYEES_REQUEST, FETCH_EMPLOYEES_SUCCESS, FETCH_EMPLOYEES_FAILED, DELETE_EMPLOYEE_REQUEST, DELETE_EMPLOYEE_SUCCESS, DELETE_EMPLOYEE_FAILED } from "./types"



export const fetchEmployeesRequest = () => ({type : FETCH_EMPLOYEES_REQUEST})
export const fetchEmployeesSuccess = (list) => ({type : FETCH_EMPLOYEES_SUCCESS , payload : list})
export const fetchEmployeesFailed = (error) => ({type : FETCH_EMPLOYEES_FAILED , payload : error})


export const deleteEmployeeRequest = () => ({type : DELETE_EMPLOYEE_REQUEST})
export const deleteEmployeeSuccess = () => ({type : DELETE_EMPLOYEE_SUCCESS})
export const deleteEmployeeFailed = () => ({type: DELETE_EMPLOYEE_FAILED})